import {
  DataSourceType,
  UNKNOWN_DATA_SOURCE_TYPE,
} from 'src/constants/dataSourceTypeDescription';
import { DataSource } from 'src/store/state/dataSources';
import { ReduxState } from 'src/store/types';

type DataSourcesByType = Record<DataSourceType, DataSource[]>;

export const dataSourcesByTypeSelector = (
  state: ReduxState
): DataSourcesByType => {
  const dataSourcesByType: DataSourcesByType = {};

  state.dataSources.dataSourceIds.forEach((dataSourceId) => {
    const dataSource = state.dataSources.dataSourcesById?.[dataSourceId];
    if (dataSource) {
      const sourceType = dataSource.type || UNKNOWN_DATA_SOURCE_TYPE;
      dataSourcesByType[sourceType] = [
        ...(dataSourcesByType[sourceType] || []),
        dataSource,
      ];
    }
  });
  return dataSourcesByType;
};
